export default "https://a.travel-assets.com/partner-portal/attachment.71fe6ad58bdf.svg";